/**
 * `cn` — the class-name joiner the vendored icon components expect.
 *
 * No clsx or tailwind-merge: the icons pass at most one className, and a
 * dependency whose whole job is joining strings is not worth the bytes in a
 * bundle this size.
 */

type ClassValue = string | undefined | null | false | 0;

export const cn = (...inputs: ClassValue[]): string => inputs.filter(Boolean).join(' ');
